module.exports = __webpack_public_path__ + "media/images/recruitment/landing/icon_plus-dbf5431535feef33bc5e31be69357b57.svg";